<p-toast></p-toast>
<p-confirmDialog key="salaryRanges"></p-confirmDialog>

<div class="flex flex-wrap align-items-end justify-content-between gap-3 mb-3">
  <div *ngIf="!isPracticeScoped" class="flex flex-column gap-1">
    <label for="salaryRangePractice" class="font-semibold">
      {{ 'layout.configurations.evaluation.salaryRanges.practice' | translate }}
    </label>
    <p-dropdown
      inputId="salaryRangePractice"
      [options]="practices"
      [(ngModel)]="selectedPractice"
      (onChange)="onPracticeChange()"
      [disabled]="loading || saving || practices.length === 0"
      placeholder="{{ 'layout.configurations.evaluation.salaryRanges.practicePlaceholder' | translate }}"
      styleClass="w-12rem"
    ></p-dropdown>
  </div>

  <div *ngIf="canWrite" class="flex gap-2">
    <p-button
      data-testid="salary-ranges-cancel"
      [label]="'layout.configurations.evaluation.salaryRanges.cancel' | translate"
      severity="secondary"
      [outlined]="true"
      [disabled]="!isDirty || saving || loading"
      (onClick)="cancelChanges()"
    ></p-button>
    <p-button
      data-testid="salary-ranges-save"
      [label]="'layout.configurations.evaluation.salaryRanges.save' | translate"
      icon="pi pi-check"
      [loading]="saving"
      [disabled]="!canSave"
      (onClick)="save()"
    ></p-button>
  </div>
</div>

<p
  *ngIf="practicesLoaded && !loading && practices.length === 0"
  data-testid="salary-ranges-no-selection"
  class="salary-ranges-notice"
>
  <i class="pi pi-info-circle mr-2"></i>{{ 'layout.configurations.evaluation.salaryRanges.noSelection' | translate }}
</p>

<div class="flex justify-content-end mb-2">
  <p-button
    *emPermission="Permission.CONFIG_PERFORMANCE"
    data-testid="salary-ranges-add"
    [label]="'layout.configurations.evaluation.salaryRanges.addRange' | translate"
    icon="pi pi-plus"
    [disabled]="!canAddAnywhere || loading || saving"
    (onClick)="onAdd()"
  ></p-button>
</div>

<p-table
  [value]="ranges"
  [loading]="loading || saving"
  dataKey="categoryShortLabel"
  styleClass="p-datatable-sm p-datatable-gridlines"
>
  <ng-template pTemplate="header">
    <tr>
      <th>{{ 'layout.configurations.evaluation.salaryRanges.columns.category' | translate }}</th>
      <th *ngFor="let column of columns" class="text-center">{{ column.titleKey | translate }} (DH)</th>
      <th class="text-center">{{ 'layout.configurations.evaluation.salaryRanges.columns.actions' | translate }}</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
    <tr>
      <td class="font-semibold">{{ row.categoryShortLabel }}</td>
      <ng-container *ngFor="let column of columns">
        <td
          *ngIf="canEdit; else readOnlyCell"
          pEditableColumn
          class="text-center"
          [class.salary-range-cell-changed]="isChanged(rowIndex, column.field)"
        >
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-inputNumber
                [ngModel]="row[column.field]"
                (ngModelChange)="onCellChange(row, column.field, $event)"
                (onFocus)="selectAllOnFocus($event)"
                [min]="0"
                [minFractionDigits]="2"
                [maxFractionDigits]="2"
                inputStyleClass="w-full text-center"
              ></p-inputNumber>
            </ng-template>
            <ng-template pTemplate="output">
              {{ formatAmount(row[column.field]) }}
            </ng-template>
          </p-cellEditor>
        </td>
        <ng-template #readOnlyCell>
          <td class="text-center">
            {{ formatAmount(row[column.field]) }}
          </td>
        </ng-template>
      </ng-container>
      <td class="text-center">
        <p-button
          icon="pi pi-trash"
          styleClass="p-button-rounded p-button-text p-button-danger"
          [disabled]="loading || saving"
          (onClick)="onDelete($event, row)"
        ></p-button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="6" class="text-center text-600">
        {{ 'layout.configurations.evaluation.salaryRanges.emptyMessage' | translate }}
      </td>
    </tr>
  </ng-template>
</p-table>

<p data-testid="salary-ranges-dirham-note" class="salary-ranges-dirham-note">
  <i class="pi pi-exclamation-circle mr-2"></i>{{ 'remunerationGrid.dirhamNote' | translate }}
</p>